import {ErrorHandler, Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  public errorToNotify$ = new BehaviorSubject<any>(null);

  constructor() {
  }

  public handleError(error: any): void {
    if (!environment.production) {
      console.error('Development mode error:', error);
    }

    this.errorToNotify$.next(error)
  }
}
